import React, { useState, useEffect, useContext } from 'react';
import { PiShuffleFill as ShuffleIcon } from 'react-icons/pi';
import { Button } from 'react-bootstrap';
import { IoMdSettings as SettingsIcon } from 'react-icons/io';
import { FaUnlink as UnlinkIcon } from 'react-icons/fa';
import { StateContext } from '../../StateContainer';
import ModalVariables from '../modal/ModalVariables';

const GestioneVariabili = ({
  closeModal,
  setCurrentTab,
  dettagliNodi,
  selectedNode,
  setDettagliNodi,
}) => {
  const { showModalVariables, setShowModalVariables } =
    useContext(StateContext);

  const nodoKey = `nodo-${selectedNode?.id}`;
  const variabiliNodo = dettagliNodi?.[nodoKey]?.node_variables || [];

  // Rimozione variabile
  const handleRemoveVariable = (variabile) => {
    setDettagliNodi((prev) => {
      const nuoveVariabili = prev[nodoKey].node_variables.filter(
        (v) => v.nome_variabile !== variabile.nome_variabile
      );
      return {
        ...prev,
        [nodoKey]: {
          ...prev[nodoKey],
          node_variables: nuoveVariabili,
        },
      };
    });
  };

  // Toggle required
  const handleToggleRequired = (variabile) => {
    setDettagliNodi((prev) => {
      const nuoveVariabili = prev[nodoKey].node_variables.map((v) =>
        v.nome_variabile === variabile.nome_variabile
          ? { ...v, required: !v.required }
          : v
      );
      return {
        ...prev,
        [nodoKey]: {
          ...prev[nodoKey],
          node_variables: nuoveVariabili,
        },
      };
    });
  };

  // Cambia action
  const handleSetAction = (variabile, nuovoValore) => {
    setDettagliNodi((prev) => {
      const nuoveVariabili = prev[nodoKey].node_variables.map((v) =>
        v.nome_variabile === variabile.nome_variabile
          ? { ...v, action: nuovoValore }
          : v
      );
      return {
        ...prev,
        [nodoKey]: {
          ...prev[nodoKey],
          node_variables: nuoveVariabili,
        },
      };
    });
  };

  return (
    <div className="row">
      {variabiliNodo.length > 0 ? (
        <>
          <p className="text-center mt-3">
            Seleziona le variabili che il nodo si aspetta di ricevere
          </p>
          <table className="table">
            <thead>
              <tr>
                <th>Azione</th>
                <th>Nome Variabile</th>
                <th>Richiesto</th>
                <th>Rimuovi</th>
              </tr>
            </thead>
            <tbody>
              {variabiliNodo.map((variabile) => (
                <tr key={variabile.nome_variabile}>
                  <td>
                    <select
                      className="form-select"
                      value={variabile.action}
                      onChange={(e) =>
                        handleSetAction(variabile, e.target.value)
                      }
                    >
                      <option value="acquisisci">Acquisisci</option>
                      <option value="rimuovi">Rimuovi</option>
                      <option value="utilizza">Utilizza</option>
                    </select>
                  </td>
                  <td>{variabile.nome_variabile}</td>
                  <td className="text-center">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={variabile.required || false}
                        onChange={() => handleToggleRequired(variabile)}
                      />
                    </div>
                  </td>
                  <td className="text-center">
                    <span
                      onClick={() => handleRemoveVariable(variabile)}
                      style={{ cursor: 'pointer' }}
                    >
                      <UnlinkIcon />
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="d-flex justify-content-between mt-3">
            <Button
              className="bg-green-second text-white"
              onClick={() => setShowModalVariables(true)}
            >
              Associa nuova variabile
            </Button>
          </div>
        </>
      ) : (
        <>
          <p className="text-center mb-4 mt-3">
            Seleziona le variabili che il nodo si aspetta di ricevere
          </p>
          <div className="d-flex flex-column align-items-center justify-content-center mt-5">
            <ShuffleIcon style={{ fontSize: '50px', color: '#557CD3' }} />
            <p>Non hai ancora creato una variabile nel progetto?</p>
            <Button
              className="bg-green-second text-white mt-4"
              onClick={() => setShowModalVariables(true)}
            >
              Associa nuova variabile
            </Button>
          </div>
        </>
      )}

      {showModalVariables && (
        <ModalVariables
          closeModal={closeModal}
          setCurrentTab={setCurrentTab}
          dettagliNodi={dettagliNodi}
          selectedNode={selectedNode}
          setDettagliNodi={setDettagliNodi}
        />
      )}
    </div>
  );
};

export default GestioneVariabili;
